/**
 * VIVA HUB Users app — hub-wide user account management
 */

import React, { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import HubLayout from '../components/hub/HubLayout'
import HubAdminTabs from '../components/hub/HubAdminTabs'
import HubUsersList from '../components/hub/hub-users/HubUsersList'
import HubUserDetailPage from '../components/hub/hub-users/HubUserDetailPage'
import { getHubUsersView } from '../components/hub/hub-users/hubUsersView'

function HubUsersContent() {
  const { pathname } = useLocation()
  const userView = getHubUsersView(pathname)

  if (userView.view === 'list') {
    return <HubUsersList />
  }

  if (userView.view === 'invite') {
    return <HubUserDetailPage mode="invite" />
  }

  if (userView.view === 'create') {
    return <HubUserDetailPage mode="create" />
  }

  return <HubUserDetailPage mode="edit" />
}

export default function HubSettings() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const tab = searchParams.get('tab')
    if (tab === 'permissions' || tab === 'groups') {
      navigate('/hub/groups', { replace: true })
    }
  }, [searchParams, navigate])

  return (
    <HubLayout appName="Users">
      <p className="text-gray-600 mb-6">
        Create and manage user accounts for all VIVA HUB applications.
      </p>

      <HubAdminTabs activeTab="users" />

      <HubUsersContent />
    </HubLayout>
  )
}
